import { render } from "./NewNotificationModal.vue?vue&type=template&id=50095823&scoped=true"
import script from "./NewNotificationModal.vue?vue&type=script&lang=js"
export * from "./NewNotificationModal.vue?vue&type=script&lang=js"

import "./NewNotificationModal.vue?vue&type=style&index=0&id=50095823&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50095823"]])

export default __exports__